<!--
 * @Author: your name
 * @Date: 2021-12-13 15:40:52
 * @LastEditTime: 2021-12-15 19:26:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \GeelyEmail_Mobile\src\components\listItem\index.vue
-->
<template>
	<van-swipe-cell>
		<div class="list-item" @click="handleClick">
			<!-- <div class="item-select" v-if="isMulti">
        <img src="../../assets/img/list-item-select.png" alt="" />
      </div> -->
			<div class="item-detail">
				<div class="item-user">
					<div class="user-img">
						<!-- <img src="" alt="" /> -->
						<span :style="userHeader === 'geely' ? 'font-size:12px' : ''">
							{{ userHeader }}
						</span>
					</div>
				</div>
				<div class="item-content">
					<div class="item-name">
						<span :class="[!item.IsRead ? 'item-read' : '']">
							<span v-if="[2, 3].includes(FolderType)"> {{ item.DisplayTo | DisplayTo }} </span>
							<span v-else>
								{{ item.Sender.Name || $t('home.recipients') }}
							</span>
						</span>
						<span>{{ item.DateTimeSent | timeFormat }}</span>
					</div>
					<div class="item-title" :style="!item.IsRead ? 'font-weight: bold' : ''">
						<span class="item-title-sub">{{ item.Subject || $t('home.subjectless') }}</span>
						<span v-if="item.HasAttachments"><i class="item-incon iconfont icon-fujian"></i></span>
					</div>
					<div class="item-subtitle">
						<span>{{ item.Preview }}</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <template #right>
			<div>
				<SwiperBtn type="no-read" />
				<SwiperBtn type="star" />
				<SwiperBtn type="delete" />
			</div>
		</template> -->
	</van-swipe-cell>
</template>

<script>
import utils from '../../utils'
import SwiperBtn from '../swipeBtn'
let that = null
export default {
	data() {
		return {}
	},
	components: {
		SwiperBtn
	},
	props: {
		/* 邮件数据 */
		item: {
			type: Object,
			default: () => {
				return {}
			}
		},
		/* 是否多选 */
		isMulti: {
			type: Boolean,
			default: false
		},
		FolderType: {
			type: Number,
			default: 0
		}
	},
	created() {
		that = this
	},
	computed: {
		/* 用户头像 */
		userHeader() {
			if ([2, 3].includes(this.FolderType)) {
				if (this.item.DisplayTo && this.item.DisplayTo !== '') {
					return utils._mekaName(this.item.DisplayTo)
				} else {
					return 'geely'
				}
			} else {
				return utils._mekaName(this.item.Sender.Name)
			}
		}
	},
	methods: {
		/* 点击邮件 */
		handleClick() {
			console.log('点击邮件-----', this.item)
			let obj = { ...this.item }
			obj.IsRead = true
			this.$emit('clickEmaItem', obj)
			if (this.FolderType === 2) {
				this.$router.push({
					path: '/writemail',
					query: {
						mailid: this.item.Id,
						ftype: this.FolderType,
						etype: 4
					}
				})
			} else {
				this.$router.push({
					path: '/viewmail',
					query: {
						Id: this.item.Id,
						IsMeeting: this.item.IsMeeting,
						ftype: this.FolderType,
						AssociatedAppointmentId: this.item.AssociatedAppointmentId
					}
				})
			}
		}
	},
	filters: {
		timeFormat(e) {
			return utils._isToDayFormatter(e, utils._isDuringDate(e))
		},
		DisplayTo(e) {
			if (e && e !== '') {
				if (e.indexOf(';') > -1) {
					return e.split(';')[0]
				} else {
					return e
				}
			} else {
				return that.$t('home.recipients')
			}
		}
	}
}
</script>

<style lang="less" scoped>
.list-item {
	width: 100%;
	height: 90px;
	box-sizing: border-box;
	padding: 16px 16px 0 16px;
	overflow: hidden;
	display: flex;

	align-items: center;
	justify-content: space-between;
	.item-select {
		display: inline-block;
		width: 20px;
		height: 100%;
		margin-right: 16px;
		position: relative;
		img {
			position: relative;
			top: 8px;
			width: 20px;
			height: 20px;
		}
	}
	.item-detail {
		width: 100%;
		height: 100%;
		display: flex;
		// padding-bottom: 16px;
		align-items: center;
		justify-content: space-between;
		.item-user {
			width: 36px;
			height: 100%;
			margin-right: 10px;

			.user-img {
				width: 36px;
				height: 36px;
				line-height: 36px;
				text-align: center;
				background: #005de5;
				border-radius: 100%;
				span {
					color: #fff;
					font-size: 20px;
					font-weight: bold;
				}
				img {
					border-radius: 100%;
					width: 100% !important;
					height: 100% !important;
				}
			}
		}
		.item-content {
			flex: 1;
			height: 72px;
			border-bottom: 1px solid #ededed;
			// box-shadow: 0 1px #e5e5e5;
			.item-name,
			.item-title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				color: #333;
			}
			.item-name {
				position: relative;
				font-size: 16px;
				line-height: 16px;
				margin-bottom: 8px;
				.item-read {
					font-weight: bold;
					margin-left: 18px;
				}
				.item-read::before {
					content: '';
					position: absolute;
					top: 25%;
					left: 0;
					margin-right: 8px;
					width: 8px;
					height: 8px;
					border-radius: 100%;
					background: #005de5;
				}
			}
			.item-name > span:last-child {
				font-size: 12px;
				color: #999;
			}
			.item-title {
				width: 100%;
				font-size: 14px;
				line-height: 16px;
				margin-bottom: 6px;
				.item-title-sub {
					display: inline-block;
					width: 280px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.item-incon {
					font-weight: 500;
					color: #999;
					font-size: 14px;
				}
			}
			.item-subtitle {
				font-weight: 400 !important;
				width: 290px;
				text-align: left;
				font-size: 12px;
				color: #999999;
				line-height: 14px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		// .item-content::after {
		// 	content: '';
		// 	position: absolute;
		// 	bottom: 0;
		// 	width: 100%;
		// 	height: 1px;
		// 	background-color: #e5e5e5;
		// }
	}
}
</style>
